import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["modal", "backdrop"]
  static values = {
    dismissable: Boolean,
    autoClose: Number
  }

  connect() {
    // Prevent body scroll when modal is open
    document.body.style.overflow = "hidden"

    // Setup auto-close if specified
    const autoClose = this.hasAutoCloseValue ? this.autoCloseValue : 0
    if (autoClose > 0) {
      this.autoCloseTimeout = setTimeout(() => {
        this.dismiss()
      }, autoClose)
    }

    // Add escape key listener
    this.escapeHandler = this.handleEscape.bind(this)
    document.addEventListener("keydown", this.escapeHandler)
  }

  disconnect() {
    // Restore body scroll
    document.body.style.overflow = ""

    // Clear timeout
    if (this.autoCloseTimeout) {
      clearTimeout(this.autoCloseTimeout)
    }

    // Remove escape listener
    document.removeEventListener("keydown", this.escapeHandler)
  }

  get isDismissable() {
    return this.hasDismissableValue ? this.dismissableValue : false
  }

  handleEscape(event) {
    if (event.key === "Escape" && this.isDismissable) {
      this.dismiss()
    }
  }

  backdropClick(event) {
    // Only dismiss if clicking the backdrop itself, not the modal content
    if (event.target === this.element && this.isDismissable) {
      this.dismiss()
    }
  }

  dismiss() {
    // Add fade-out animation
    this.element.classList.add("celebration-fade-out")

    // Remove after animation completes
    setTimeout(() => {
      this.element.remove()
    }, 300)
  }

  // Navigate to next lesson
  nextLesson(event) {
    this.dismiss()
    // The link/button will handle navigation via Turbo
  }

  // Navigate to certificate
  viewCertificate(event) {
    this.dismiss()
    // The link will handle navigation
  }
}
